import React, { FC, Suspense } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import Loader from 'components/UI/Loader';
import Container from './container';
import { useAuthDetail } from './hooks/useAuthDetail';
import FormMakeup from './makup';
import SignIn from './SignIn';
import SignUp from './SignUp';
import ForgotPassword from './ForgotPassword';
import ChangePassword from './ChangePassword';

const Auth: FC = () => {
  const { match, getToRoute } = useAuthDetail();
  return (
    <Container>
      <Switch>
        <Route
          exact
          path={`${match.path}/sign-in`}
          render={(routeProps) => (
            <Suspense fallback={<Loader />}>
              <FormMakeup {...routeProps} mode="sign-in">
                <SignIn />
              </FormMakeup>
            </Suspense>
          )}
        />
        <Route
          path={`${match.path}/sign-up`}
          render={(routeProps) => (
            <Suspense fallback={<Loader />}>
              <FormMakeup {...routeProps} mode="sign-up">
                <SignUp />
              </FormMakeup>
            </Suspense>
          )}
        />
        <Route
          exact
          path={`${match.path}/forgot-password`}
          render={(routeProps) => (
            <Suspense fallback={<Loader transparent />}>
              <FormMakeup {...routeProps} mode="forgot-password">
                <ForgotPassword />
              </FormMakeup>
            </Suspense>
          )}
        />
        <Route
          exact
          path={`${match.path}/change-password`}
          render={(routeProps) => (
            <Suspense fallback={<Loader transparent />}>
              <FormMakeup {...routeProps} mode="change-password">
                <ChangePassword />
              </FormMakeup>
            </Suspense>
          )}
        />
        <Redirect from="/auth" to={getToRoute()} />
      </Switch>
    </Container>
  );
};

export default Auth;
